import { Search ,CorrespondanceTrackingModel} from './../../shared/user.model';
import { Component, OnInit } from '@angular/core';
import { DISABLED } from '@angular/forms/src/model';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-ct-form',
  templateUrl: './ct-form.component.html',
  styleUrls: ['./ct-form.component.css']
})

export class CtFormComponent implements OnInit {

  OutwardNo;
  InwardNo;
  OutwardNumber;
  InwardNumber;
  fileToUpload: any;
  FeasibilityPDFUrl: any;
  CorrespondanceTracking:any={};
  mode: any;
  isUpdate: boolean;  
  Id: any;  
  roleList;
  title = "Add Correspondence Tracking";
  constructor(private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) 
  {
    //this.Petition.PetitionReceivedDate = new Date().toISOString().substring(0, 10);
  }  

  ngOnInit() 
  {
    // this.route.params.subscribe(params => {
    // this.mode = params['mode'];
    // this.Id=params['Id'];
    // });
     //From URL
     this.mode=localStorage.getItem('mode');
     this.Id= localStorage.getItem('CTId');
     localStorage.removeItem('CTId'); 
     localStorage.removeItem('mode');
     
    if(this.mode == 'view' || this.mode == 'edit'){
      this.GetAllDetailsinViewMode(this.Id);
    }
    if (this.mode == 'view')
    {
      this.title = "View Correspondence Tracking";
    }
    if (this.mode == 'edit')
    {
      this.title = "Edit Correspondence Tracking";
    }
    
    this.GetRolesforSelectedOffice();
  }

  GetRolesforSelectedOffice() 
  {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getRolesforSelectedOffice().subscribe(
      (data:any) => {
        this.roleList = data;          
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
      });
  }

  Reset(roleForm)
  {    
    roleForm.reset();
  }

  GetAllDetailsinViewMode(Id)  {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetInwardOutwardtoView(Id)
      .subscribe(
        (data:any) => {          
          this.CorrespondanceTracking=data;           
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

 
  FileInput(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.CorrespondanceTracking.TrackingOriginalPath="";
      return true;
    }
    if (uploadedFilename.match(regex) && (size <= 5048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.FeasibilityPDFUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadcorrespondance(data);
      x.subscribe(
        (response) => {
          // console.log(response);
          // this.app.APP_PA_PhotoErrorMessage="";

        }, (error) => {
          
          let i: any = document.getElementById('TrackingOriginalPath');
          i.value = "";
          swal("Warning!",error.status,"warning");
          if (error.status == 400) {
            //this.FeasibilityPDFUrl = "assets/images/image-default.png";            
            swal('Warning!', error.error.Message, 'warning');
          }
          else
          {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          }
        });
    }
    else {
      let i: any = document.getElementById('TrackingOriginalPath');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
  }
  getFeasibilityPDFUrl() {
    let imagename = null;
    try {
      //imagename = document.getElementById('ScannedDocument');
      imagename = document.getElementById('TrackingOriginalPath');
      return imagename.files[0].name;
    }
    catch (e) {
      return null;
    }
  }

  update(form: NgForm) {
    document.getElementById('loader-spinner').style.display = "block";
    form.value.InwardNumber=this.CorrespondanceTracking.InwardNumber;
    form.value.OutwardNumber=this.CorrespondanceTracking.OutwardNumber;
    this.userService.updatecorrespondanceTrackingDetails(this.Id,form.value)
      .subscribe(
        (data:any) => {
         this.isUpdate=true;
          document.getElementById('loader-spinner').style.display = "none";
          swal('','Updated Successfully!','success');
          this.router.navigate(['/home/ct']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          alert(error.error.Message);
        });
  }
  /*GetInwardNo()
  {
      debugger; 
      
      if(this.CorrespondanceTracking.CheckRadio=="In")
      {  
      this.CorrespondanceTracking.OutwardNumber='';
      }
    document.getElementById('loader-spinner').style.display = "block";
      this.userService.GetInwardNo()
      .subscribe(
      (data:any) => {
        this.CorrespondanceTracking.InwardNumber=data;
        //this.CorrespondanceTracking=data.CorrespondanceTracking.InwardNumber;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });    
    }

    GetOutwardNo()
  {
    debugger;
    if(this.CorrespondanceTracking.CheckRadio=="Out")
    {  
    this.CorrespondanceTracking.InwardNumber='';
    }
    document.getElementById('loader-spinner').style.display = "block";
      this.userService.GetOutwardNo()
      .subscribe(
      (data:any) => {
        this.CorrespondanceTracking.OutwardNumber=data;
       // this.CorrespondanceTracking.OutwardNo=data;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
    }*/
   
  
  Save(form:NgForm)
  {  
    if (this.CorrespondanceTracking.CheckRadio == "" || this.CorrespondanceTracking.CheckRadio == null)
    {      
      swal("Warning!", "Please Select Inward or Outward Number.", "warning");
    }
    else if (this.CorrespondanceTracking.TrackingOriginalPath == null || this.CorrespondanceTracking.TrackingOriginalPath == "")
    {
      swal("Warning!", "Please select a file to be uploaded.", "warning");        
    }
    else if(this.CorrespondanceTracking.CheckRadio=="In" && (this.CorrespondanceTracking.AssignedTo == null || this.CorrespondanceTracking.AssignedTo == ""))
    {      
      swal("Warning!", "Please select Assigned To User.", "warning");
    }
    else
    {
      if(this.mode=='edit')
      {      
        this.update(form)
        //this.router.navigate(['/home/district']);
      }
      else
      {
        //this.CorrespondanceTracking.ScannedDocument=this.getFeasibilityPDFUrl();
        if(this.CorrespondanceTracking.CheckRadio=="In")
        {  
          this.CorrespondanceTracking.InwardOrOutWard='In';
        }
        else
        {
          this.CorrespondanceTracking.InwardOrOutWard='Out';
        }
        document.getElementById('loader-spinner').style.display = "block";
        this.userService.AddCorrespondanceTracking(this.CorrespondanceTracking).subscribe(
        (data:any) => {         
          if(this.CorrespondanceTracking.CheckRadio=="In")
          {  
            swal('','Inward Number: ' + data + ' Added Successfully!','success');
          }
          else
          {
            swal('','Outward Number: ' + data + ' Added Successfully!','success');
          }
          this.router.navigate(['/home/ct']);
          
        }, (error) => {
          document.getElementById('loader-spinner').style.display="none";
          this.errorHandler.HandlerError(error);
        });
      }
    }
  }  
}



// WEBPACK FOOTER //
// ./src/app/correspondence-tracking/ct-form/ct-form.component.ts